import React, {useState, useEffect, useContext} from 'react'
import { useParams } from 'react-router-dom'
import { db } from '../../Firebase/firebase'
import { AuthContext } from '../../Context/AuthContext/AuthContext'
import { ThemeContext } from '../../Context/ThemeContext/ThemeContext'

import './UserProfileAside.css'

const UserProfileAside = () => {
  const { currentUser } = useContext(AuthContext)
  const { isLight } = useContext(ThemeContext)
  const { userName } = useParams()

  const [user, setUserName] = useState('')
  const [profilePic, setProfilePic] = useState('')
  const [bio, setBio] = useState('')


  useEffect(() => {
    db.collection('users').where("userName","==",userName).onSnapshot((snapshot) => {
      snapshot.docs.map(doc => {
        const { userName, bio, profilePic } = doc.data()
        setUserName(userName)
        setProfilePic(profilePic)
        setBio(bio)
      })
    })
  } ,[currentUser])
  return (
    
    <aside className={`user-profile-data ${isLight ? "" : "dark"}`}>
      {user ? (
        <div className="user-profile-data__container">
          <img src={profilePic} alt="user profile" className="user-profile-data__img"/>
          <h1 className="user-profile-data__username">TPu/{user}</h1>
          <p className="user-profile-data__bio">{bio}</p>
      </div>
      ) : (
        
        <h1 className="user-profile-data__no-user">No such user exists</h1>
      )}
      
    </aside>
  )
}

export default UserProfileAside